import { Box, Typography } from '@mui/joy';
import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import { SignUpProvider } from '@MP/features/auth';
import ConfirmDialog from '@MP/shared/components/dialog/ConfirmDialog';

const SignUpPage = () => {
  const [openSignupConfirmDialog, setOpenSignupConfirmDialog] = React.useState(true);
  const navigate = useNavigate();
  return (
    <SignUpProvider>
      <Outlet />
      <ConfirmDialog
        open={openSignupConfirmDialog}
        warning
        onResult={(result) => {
          if (!result) {
            navigate('/login', { replace: true });
          }

          setOpenSignupConfirmDialog(false);
        }}
        title="병원, 의료진 사용자만 가입이 가능합니다"
        message={
          <Box textAlign={'center'}>
            <Typography sx={{ fontSize: 14, color: '#666' }}>
              개인 회원은 가입 불가능하며 가입시 계정이 삭제됩니다.
            </Typography>
          </Box>
        }
      />
    </SignUpProvider>
  );
};

export default SignUpPage;
